import './XYChartTooltipTemplate.css';
export var body = '_1ej2mte0-2-0-1';